import createConstant from '../../utils/createConst'

export const GET_USER_CREATED_EVENTS = createConstant('profile/GET_USER_CREATED_EVENTS')
export const GET_USER_CREATED_INFOS = createConstant('profile/GET_USER_CREATED_INFOS')
export const GET_USER_CREATED_PRODUCTS = createConstant('profile/GET_USER_CREATED_PRODUCTS')
export const GET_EVENT = createConstant('profile/GET_EVENT')
export const GET_FAVORITE_PRODUCTS = createConstant('profile/GET_FAVORITE_PRODUCTS')
export const GET_FAVORITE_INFOS = createConstant('profile/GET_FAVORITE_INFOS')
export const GET_FAVORITE_EVENTS = createConstant('profile/GET_FAVORITE_EVENTS')
export const GET_NOTIFICATION = createConstant('GET_NOTIFICATION')
export const CREATE_EVENT = createConstant('profile/CREATE_EVENT')
export const CREATE_INFO = createConstant('CREATE_INFO')
export const CREATE_PRODUCT = createConstant('CREATE_PRODUCT')



// WEBPACK FOOTER //
// ./src/modules/Profile/constants.js